/*
  Data structure of messages recieved by partner host.
  At the moment the only host is AppSource.
 */ export var PartnersHostMessageType = /*#__PURE__*/ function(PartnersHostMessageType) {
    PartnersHostMessageType[PartnersHostMessageType["Ready"] = 0] = "Ready";
    PartnersHostMessageType[PartnersHostMessageType["Login"] = 1] = "Login";
    PartnersHostMessageType[PartnersHostMessageType["ChangeUrlDetails"] = 2] = "ChangeUrlDetails";
    PartnersHostMessageType[PartnersHostMessageType["ChangeUrlGallery"] = 3] = "ChangeUrlGallery";
    PartnersHostMessageType[PartnersHostMessageType["StoreFilterLocation"] = 4] = "StoreFilterLocation";
    PartnersHostMessageType[PartnersHostMessageType["StoreContactDetails"] = 5] = "StoreContactDetails";
    PartnersHostMessageType[PartnersHostMessageType["ContentHeightChange"] = 6] = "ContentHeightChange";
    return PartnersHostMessageType;
}({});
